/*
  Alexander Cruzado · Galería filtrada por color (referencia Polo).
  Al elegir un color, la galería del producto muestra solo las fotos de ese color.
  Las fotos que no pertenecen a ningún color se muestran siempre.
  Máximo 5 fotos por color (pedido del cliente, 25-sep); los videos los filtra ac-gallery-fix (máx. 2).

  Las diapositivas que no corresponden se mueven fuera del carrusel (no se ocultan con CSS),
  porque Swiper sigue contando las que están ocultas y pierde la posición.
*/
(function () {
  'use strict';

  var HIDE = 'ac-hide-media';
  // Tope pedido por el cliente (25-sep): como mucho 5 fotos por color (los videos van aparte, máx. 2)
  var MAX_PHOTOS = 5;

  function baseOf(url) {
    if (!url) return '';
    var file = String(url).split('?')[0].split('/').pop();
    file = file.replace(/_\d+x\d*(@\dx)?(?=\.)/i, '');
    file = file.replace(/\.(jpe?g|png|webp|avif|gif)$/i, '');
    file = file.replace(/[-_]\d+$/, '');
    return file.toLowerCase();
  }

  function colorIndexOf(product) {
    var idx = -1;
    (product.options || []).forEach(function (opt, i) {
      var name = (typeof opt === 'string' ? opt : opt.name || '').toLowerCase().trim();
      if (idx === -1 && /color|colour|tono/.test(name)) idx = i;
    });
    return idx;
  }

  function imgSrc(node) {
    var img = node.querySelector ? node.querySelector('img') : null;
    return (img && (img.getAttribute('src') || img.currentSrc)) || node.getAttribute('data-image-url') || '';
  }

  function Gallery(container, product) {
    this.container = container;
    this.product = product;
    this.map = {};
    this.colorIndex = colorIndexOf(product);
    var self = this;
    (product.variants || []).forEach(function (v) {
      var src = v.featured_image && (v.featured_image.src || v.featured_image);
      if (!src || self.colorIndex === -1) return;
      var b = baseOf(src);
      if (!b) return;
      // Una misma foto puede pertenecer a varios colores (p. ej. fotos provisionales)
      if (!self.map[b]) self.map[b] = [];
      if (self.map[b].indexOf(v.options[self.colorIndex]) === -1) self.map[b].push(v.options[self.colorIndex]);
    });
    this.swiperEl = container.querySelector('.product-gallery-swiper');
    this.wrapper = this.swiperEl && this.swiperEl.querySelector('.swiper-wrapper');
    if (this.wrapper) {
      // 09-oct: la ficha ya llega con las fotos de otros colores en este depósito (main-product)
      this.stash = this.swiperEl.parentNode.querySelector(':scope > .ac-media-stash');
      if (!this.stash) {
        this.stash = document.createElement('div');
        this.stash.className = 'ac-media-stash';
        this.stash.hidden = true;
        this.swiperEl.parentNode.appendChild(this.stash);
      }
    }
  }

  Gallery.prototype.color = function () {
    var groups = this.container.querySelectorAll('.product-option-group');
    for (var i = 0; i < groups.length; i++) {
      var label = groups[i].querySelector('.product-option-label');
      if (label && /^\s*color/i.test(label.textContent)) {
        var val = groups[i].querySelector('.selected-option-value');
        if (val && val.textContent.trim()) return val.textContent.trim();
        var sw = groups[i].querySelector('.product-swatch-btn.is-selected');
        if (sw) return (sw.getAttribute('data-value') || '').trim();
      }
    }
    return null;
  };

  Gallery.prototype.belongs = function (node, color) {
    // 09-oct: los videos tienen dueño por su texto alternativo (= nombre del color); así no
    // entran por un instante al carrusel al cambiar de color
    if (!this.vmap) {
      this.vmap = {};
      try { this.vmap = JSON.parse((document.getElementById('ac-video-map') || {}).textContent || '{}'); } catch (e) { this.vmap = {}; }
      var t = document.querySelector('.product-title, h1');
      this.generic = ['', t ? t.textContent.trim().toLowerCase() : ''];
    }
    var vid = node.dataset && node.dataset.imageId;
    if (vid && Object.prototype.hasOwnProperty.call(this.vmap, vid)) {
      var alt = String(this.vmap[vid] || '').trim();
      return alt === color || this.generic.indexOf(alt.toLowerCase()) !== -1;
    }
    var owners = this.map[baseOf(imgSrc(node))];
    return !owners || owners.indexOf(color) !== -1;
  };

  // Aviso «fotos próximamente» para colores sin fotos (carrusel móvil y grilla de escritorio)
  Gallery.prototype.placeholder = function (color) {
    var self = this;
    var html = function (tag, cls) {
      var el = document.createElement(tag);
      el.className = cls + ' ac-ph';
      var dot = '#e9e5dc';
      self.container.querySelectorAll('.product-swatch-btn[data-value]').forEach(function (b) {
        if (b.getAttribute('data-value') === color && b.style.background) dot = b.style.background;
      });
      el.innerHTML = '<div class="product-featured-image-wrapper ac-ph__box"><div class="ac-ph__inner">' +
        '<span class="ac-ph__dot" style="background:' + dot + '"></span>' +
        '<span class="ac-ph__name"></span><span class="ac-ph__txt">Fotos de este color muy pronto</span></div></div>';
      el.querySelector('.ac-ph__name').textContent = color || '';
      return el;
    };
    var olds = this.container.querySelectorAll('.ac-ph');
    olds.forEach(function (n) { n.parentNode && n.parentNode.removeChild(n); });
    if (!color) return;
    if (this.wrapper) this.wrapper.insertBefore(html('div', 'swiper-slide product-featured-image-slide'), this.wrapper.firstChild);
    var grid = this.container.querySelector('.product-gallery-grid');
    if (grid) grid.insertBefore(html('div', 'product-gallery-grid-item'), grid.firstChild);
  };

  Gallery.prototype.apply = function () {
    var color = this.color();
    if (!color) return;
    var self = this;

    // 1. Diapositivas: devolver todas al carrusel y volver a ordenarlas
    if (this.wrapper && this.stash) {
      this.container.querySelectorAll('.ac-ph').forEach(function (n) { n.parentNode && n.parentNode.removeChild(n); });
      Array.prototype.slice.call(this.stash.children).forEach(function (s) { self.wrapper.appendChild(s); });
      Array.prototype.slice.call(this.wrapper.children)
        .sort(function (a, b) { return (+a.dataset.index || 0) - (+b.dataset.index || 0); })
        .forEach(function (s) { self.wrapper.appendChild(s); });

      // 09-oct: la foto principal del color va primero (igual que la grilla de escritorio)
      var feat = null;
      (this.product && this.product.variants || []).some(function (v) {
        if (v.options[self.colorIndex] === color && v.featured_media && v.featured_media.id) { feat = String(v.featured_media.id); return true; }
        return false;
      });
      if (feat) {
        var fs = this.wrapper.querySelector(':scope > [data-image-id="' + feat + '"]');
        if (fs) this.wrapper.insertBefore(fs, this.wrapper.firstChild);
      }
      var keep = Array.prototype.slice.call(this.wrapper.children)
        .filter(function (s) { return self.belongs(s, color); });
      // 09-oct: el color no tiene fotos propias → en vez de mostrar TODAS las fotos del producto
      // (mezclaba cuadros, rayas…), se muestra un aviso con el tono del color.
      var ownPhotos = keep.filter(function (s) { return !!self.map[baseOf(imgSrc(s))]; });
      this.placeholder(!ownPhotos.length ? color : null);
      if (!ownPhotos.length) {
        Array.prototype.slice.call(this.wrapper.children).forEach(function (s) {
          if (!s.classList.contains('ac-ph')) self.stash.appendChild(s);
        });
        self.container.querySelectorAll('.product-thumbnail-btn, .product-gallery-grid-item').forEach(function (n) {
          n.classList.toggle(HIDE, !n.classList.contains('ac-ph'));
        });
        var sw = this.swiperEl && this.swiperEl.swiper;
        if (sw) { try { sw.update(); sw.slideTo(0, 0); } catch (e) { /* noop */ } }
        return;
      }

      var photos = 0;
      Array.prototype.slice.call(this.wrapper.children).forEach(function (slide) {
        var own = !!self.map[baseOf(imgSrc(slide))]; // foto identificada de un color (no video ni foto compartida)
        if (own && self.belongs(slide, color)) photos++;
        if (!self.belongs(slide, color) || (own && photos > MAX_PHOTOS)) {
          self.stash.appendChild(slide);
        } else {
          // Cargar de inmediato: si no, la foto aparece en blanco al cambiar de color
          var img = slide.querySelector('img');
          if (img && img.getAttribute('loading') === 'lazy') {
            img.setAttribute('loading', 'eager');
            img.setAttribute('fetchpriority', 'high');
          }
        }
      });
    }

    // 2. Miniaturas y grilla: se ocultan con CSS (así el lightbox mantiene sus índices)
    ['.product-thumbnail-btn', '.product-gallery-grid-item'].forEach(function (sel) {
      var tphotos = 0;
      self.container.querySelectorAll(sel).forEach(function (node) {
        // Los videos (sin <img>) los filtra ac-gallery-fix por color: aquí no se tocan
        if (!baseOf(imgSrc(node))) return;
        var ok = self.belongs(node, color);
        if (ok && self.map[baseOf(imgSrc(node))]) { tphotos++; if (tphotos > MAX_PHOTOS) ok = false; }
        node.classList.toggle(HIDE, !ok);
      });
    });

    // 3. Reiniciar el carrusel en la primera foto del color
    var swiper = this.swiperEl && this.swiperEl.swiper;
    if (swiper) {
      try {
        swiper.update();
        swiper.slideTo(0, 0);
        if (swiper.pagination && swiper.pagination.render) {
          swiper.pagination.render();
          swiper.pagination.update();
        }
      } catch (e) { /* noop */ }
    }

    var thumbs = this.container.querySelectorAll('.product-thumbnail-btn:not(.' + HIDE + ')');
    if (thumbs.length) {
      this.container.querySelectorAll('.product-thumbnail-btn').forEach(function (t) { t.classList.remove('is-active'); });
      thumbs[0].classList.add('is-active');
      // Galería simple (producto destacado en la home, sin Swiper): la foto grande pasa a la portada del color
      if (!swiper) {
        var main = this.container.querySelector('.product-featured-image');
        var url = thumbs[0].getAttribute('data-image-url');
        if (main && url && main.getAttribute('src') !== url) { main.setAttribute('src', url); main.removeAttribute('srcset'); }
      }
    }
  };

  // Las miniaturas del tema llaman a slideTo con el índice original: lo corregimos
  Gallery.prototype.bindThumbs = function () {
    var self = this;
    this.container.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('.product-thumbnail-btn');
      if (!btn || btn.classList.contains(HIDE)) return;
      var visible = Array.prototype.slice.call(self.container.querySelectorAll('.product-thumbnail-btn:not(.' + HIDE + ')'));
      var pos = visible.indexOf(btn);
      if (pos === -1) return;
      var swiper = self.swiperEl && self.swiperEl.swiper;
      if (!swiper) return; // galería simple: el tema cambia la foto por su cuenta
      e.stopPropagation();
      e.preventDefault();
      visible.forEach(function (t) { t.classList.remove('is-active'); });
      btn.classList.add('is-active');
      swiper.slideTo(pos);
    }, true);
  };

  // Diseños con el nombre y el orden del cliente (PDF 25-sep) en cualquier selector «Diseño»
  // (la ficha ya lo hace con ac-design-picker; esto cubre el producto destacado de la home)
  var DESIGN_ORDER = ['A rayas', 'Rayas', 'A cuadros', 'Cuadros', 'Labrados', 'Labrado', 'Colores enteros', 'Colores lisos', 'Estampados', 'Estampado'];
  var DESIGN_LABEL = { 'A rayas': 'Rayas', 'A cuadros': 'Cuadros', 'Labrados': 'Labrado', 'Colores enteros': 'Colores lisos', 'Estampados': 'Estampado', 'Estampadas': 'Estampado' };
  function relabelDesigns(container) {
    container.querySelectorAll('.product-option-group').forEach(function (g) {
      // OJO: la bandera es propia. ac-design-picker usa dataset.acDesign y si se la pisamos
      // no llega a instalar el filtro Diseño → Color de la ficha.
      if (g.dataset.acRelabel || g.dataset.acDesign) return;
      var label = g.querySelector('.product-option-label');
      if (!label || !/^\s*dise/i.test(label.textContent)) return;
      var pills = Array.prototype.slice.call(g.querySelectorAll('.product-pill-btn[data-value]'));
      if (!pills.length) return;
      g.dataset.acRelabel = '1';
      var list = pills[0].parentNode;
      pills.sort(function (a, b) { return DESIGN_ORDER.indexOf(a.dataset.value) - DESIGN_ORDER.indexOf(b.dataset.value); });
      pills.forEach(function (p) { list.appendChild(p); if (DESIGN_LABEL[p.dataset.value]) p.textContent = DESIGN_LABEL[p.dataset.value]; });
      var fix = function () {
        var v = g.querySelector('.selected-option-value');
        if (v && DESIGN_LABEL[v.textContent.trim()]) v.textContent = DESIGN_LABEL[v.textContent.trim()];
      };
      fix();
      new MutationObserver(fix).observe(label, { childList: true, characterData: true, subtree: true });
    });
  }

  // Galerías a atender: la ficha de producto y cualquier «producto destacado» (home) con su enlace a la ficha
  function targets() {
    var out = [];
    var path = window.location.pathname.split('?')[0].replace(/\/$/, '');
    if (/\/products\//.test(path)) {
      var c = document.querySelector('.product-page-container, .template-product, #MainContent') || document;
      if (c.querySelector('.product-featured-image-slide, .product-thumbnail-btn')) out.push({ container: c, path: path });
      return out;
    }
    document.querySelectorAll('.product-gallery-switcher').forEach(function (sw) {
      var section = sw.closest('.shopify-section') || sw.parentNode;
      var link = section.querySelector('a[href*="/products/"]');
      if (!link) return;
      var p = link.getAttribute('href').split('?')[0].split('#')[0].replace(/\/$/, '');
      out.push({ container: section, path: p });
    });
    return out;
  }

  function start() {
    var enFicha = /\/products\//.test(window.location.pathname);
    targets().forEach(function (t) {
      // Solo fuera de la ficha (producto destacado de la home): en la ficha manda ac-design-picker
      if (!enFicha) relabelDesigns(t.container);
      startOne(t);
    });
  }

  function startOne(t) {
    var container = t.container, path = t.path;
    fetch(path + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (product) {
        if (!product) return;
        var g = new Gallery(container, product);
        if (g.colorIndex === -1 || !Object.keys(g.map).length) return;
        window.acGallery = g;

        var run = function () { g.apply(); };
        var later = function () { setTimeout(run, 80); setTimeout(run, 400); };

        g.bindThumbs();
        run();
        setTimeout(run, 700); // después de que el tema inicia Swiper

        container.addEventListener('click', function (e) {
          if (e.target.closest('.product-swatch-btn, .product-pill-btn')) later();
        });

        container.querySelectorAll('.product-option-group').forEach(function (grp) {
          var label = grp.querySelector('.product-option-label');
          var val = grp.querySelector('.selected-option-value');
          if (label && val && /^\s*color/i.test(label.textContent)) {
            new MutationObserver(later).observe(val, { childList: true, characterData: true, subtree: true });
          }
        });
      })
      .catch(function () { /* noop */ });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
